import React from "react";
import {
	BorderLinearProgress,
	Box,
	Container,
	Counter,
	Text,
	TextContainer
} from "./styles";
//import box from "assets/club-gifts-galore/v2/temp-box.png";

interface ProgressBarProps {
	isCurrentTierActive: boolean;
	currentUsers: number;
	totalUsers: number;
	boxIconImageUrl: string | undefined;
}

const ProgressBar = ({
	isCurrentTierActive,
	currentUsers,
	totalUsers,
	boxIconImageUrl
}: ProgressBarProps) => {
	const isCurrentTierComplete = currentUsers === totalUsers;

	return (
		<Container>
			<BorderLinearProgress
				className={isCurrentTierComplete ? "completed" : ""}
				variant="determinate"
				value={(currentUsers * 100) / totalUsers}
			/>
			<TextContainer
				style={{
					color:
						isCurrentTierActive || isCurrentTierComplete ? "#fff" : "#C4C4C4"
				}}
			>
				<Text>
					{isCurrentTierComplete
						? "COMPLETED"
						: !isCurrentTierActive && "LOCKED"}
				</Text>
				{!isCurrentTierComplete && (
					<Counter>{`${currentUsers}/${totalUsers}`}</Counter>
				)}
			</TextContainer>
			<Box src={boxIconImageUrl || ""} />
		</Container>
	);
};

export default ProgressBar;
